/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartLayout_portfolioItems$ref = any;
type CartLayout_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartContainer_viewer$ref: FragmentReference;
export type CartContainer_viewer = {|
  +portfolios: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +items: ?{|
          +totalResults: ?number,
          +pageInfo: {|
            +hasNextPage: boolean,
            +endCursor: ?string,
          |},
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +item: ?{|
                +serviceId: ?string,
                +ecommerceTrackingParams: ?any,
              |}
            |}
          |}>,
          +$fragmentRefs: CartLayout_portfolioItems$ref,
        |}
      |}
    |}>
  |},
  +$fragmentRefs: CartLayout_viewer$ref,
  +$refType: CartContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartContainer_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": null
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int!",
      "defaultValue": 10
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartLayout_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "portfolios",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "portfolioTypes",
          "value": [
            "CART"
          ],
          "type": "[PortfolioTypes]"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": "[String]"
        }
      ],
      "concreteType": "PortfoliosConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfoliosEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": "items",
                  "name": "__CartItemList_items_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioItemsConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "CartLayout_portfolioItems",
                      "args": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "totalResults",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "pageInfo",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "hasNextPage",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "endCursor",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PortfolioItemsEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PortfolioItemV2",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "item",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Item",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "serviceId",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "ecommerceTrackingParams",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "__typename",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "cursor",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '843b1e6ba595ba3fb01f3540e8a4e967';
module.exports = node;
